import { useBoolean } from "../../helpers/useBoolean";
import { Icon, message } from "antd";
import React from "react";
import styled from "styled-components/macro";
import "styled-components/macro";
import {
  makeAuthorizedDeleteRequestToBackend,
  makeAuthorizedPostRequestToBackend,
  makeUrl
} from "../../helpers/backendApi"; // DO NOT REMOVE. Necessary for using the css={`...`} prop

const useStarUnstarActions = partnerId1 => ({
  unstarPartner: async partnerId2 =>
    await makeAuthorizedDeleteRequestToBackend({
      url: makeUrl(`stars/${partnerId1 || partnerId2}`),
      axiosConfig: undefined
    }),
  starPartner: async partnerId2 =>
    await makeAuthorizedPostRequestToBackend({
      url: makeUrl(`stars/${partnerId1 || partnerId2}`),
      data: {},
      axiosConfig: undefined
    })
});

const YellowIcon = styled(Icon)`
  font-size: 1rem;
  vertical-align: middle;
`;

const DivToPutIconInMiddleOfCell = styled.div`
  height: 100%;
  width: 100%;
  text-align: center;
`;

export function StarCellRenderer({ value, data, api }) {
  const partnerId = data.dp__PartnerId;
  // noinspection JSUnresolvedVariable
  const partnerName = data.dp__PartnerName;

  // const starred = useIsStarred(partnerId);
  const starred = useBoolean(value);

  const { starPartner, unstarPartner } = useStarUnstarActions(partnerId);

  const onClick = async ev => {
    ev.preventDefault();
    if (!starred.value) {
      try {
        starred.setTrue();
        await starPartner(partnerId);
        message.success(`Successfully starred ${partnerName}`, 1);
        api.updateRowData({ update: [{ ...data, starred: 1 }] });
      } catch (e) {
        starred.setFalse();
        message.error(`Failed to star ${partnerName}`);
      }
    } else {
      try {
        starred.setFalse();
        await unstarPartner(partnerId);
        message.success(`Successfully un-starred ${partnerName}`, 1);
        api.updateRowData({ update: [{ ...data, starred: 0 }] });
      } catch (e) {
        starred.setTrue();
        message.error(`Failed to un-star ${partnerName}`);
      }
    }
  };

  return (
    <DivToPutIconInMiddleOfCell>
      <YellowIcon
        type="star"
        theme={starred.value ? "filled" : "outlined"}
        css={`
          & {
            color: ${starred.value
              ? "rgba(242,184,36, 0.8)"
              : "rgba(242,184,36, 0.4)"};
          }
          &:hover {
            color: ${starred.value
              ? "rgba(242,184,36, 0.4)"
              : "rgba(242,184,36, 0.8)"};
          }
        `}
        onClick={onClick}
      />
    </DivToPutIconInMiddleOfCell>
  );
}
